export const USERNAME_MIN_LENGTH = 3
export const USERNAME_MAX_LENGTH = 30

const defaultOptions = {
  minLength: USERNAME_MIN_LENGTH,
  maxLength: USERNAME_MAX_LENGTH,
}

export const INVALID_USERNAMES = [
  'about',
  'pricing',
  'home',
  'pausewithme',
  'pausly',
  'pausli',
  'support',
  'signup',
  'sign-up',
  'login',
  'log-in',
  'enyo',
]

export const isValidUsername = (
  name: string | null | undefined,
  options: Partial<typeof defaultOptions> = {},
) => {
  const opts = { ...defaultOptions, ...options }
  // This regex also exists as a check in postgres, so make sure to update on
  // both sides.
  return (
    !!name &&
    !!name.match(/^([0-9\p{Ll}]+)(-[0-9\p{Ll}]+)*$/gu) &&
    !INVALID_USERNAMES.includes(name) &&
    name.length >= opts.minLength &&
    name.length <= opts.maxLength
  )
}

export const convertToValidUsername = (name: string | null | undefined) =>
  (name ?? '')
    .toLowerCase()
    .replace(/[^0-9\p{L}]/gu, '-')
    .replaceAll(/-{2,}/g, '-')
    .replace(/(^-|-$)/, '')
